<template>
    <div class='copy-card'
        :class="{'slim-card': slimCard === true}"
        @click.stop="() => copyText(text)"
    >
        <div>
            <span v-if="copying">Copied!</span>
            <span v-else>Click to copy url</span>
        </div>
        <span v-if="!slimCard">
            <span v-if="label">{{ label }}</span>
            <span>{{ text }}</span>
        </span>
    </div>
</template>

<script>
export default {
    props: ['label', 'text', 'slimCard'],
    data: () => ({ copying: false }),
    methods: {
        copyText: function () {
            this.copying = true
            const textElement = document.createElement('textarea')
            textElement.value = this.text
            textElement.setAttribute('readonly', '')
            textElement.style.position = 'absolute'
            textElement.style.left = '-9999px'
            document.body.appendChild(textElement)
            textElement.select()
            document.execCommand('copy')
            document.body.removeChild(textElement)
            window.setTimeout(() => {
                this.copying = false
            }, 500);
        }
    }
}
</script>

<style lang='scss' scoped>
.copy-card {
    display: flex;
    background-color: rgb(204, 218, 204);
    border-radius: 5px;
    transition: background-color .3s;
    cursor: pointer;
    &:hover {
        background-color:  rgb(162, 189, 155);
    }
    &:active {
        background-color: rgb(145, 185, 148);
    }
    div {
        width: 80px;
        background-color:  rgb(79, 112, 79);
        border-radius: 5px 0 0 5px;
        color: rgb(222, 235, 221);
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        span{
            width: 100%;
        }
    }
    & span {
        width: calc(100% - 80px);
        padding: 10px;
        word-break: break-word;
        span {
            display: block;
            width: 96%;
            padding-top: 4px;
            padding-bottom: 4px;
            font-size: .9rem;
            &:first-child{
                font-size: 1rem;
                font-weight: bold;
                color: rgb(63, 63, 63);
            }
        }
    }
    &.slim-card {
        width: 96%;
        margin: 15px auto 10px auto;
        div {
            background: transparent;
            color: rgb(70, 70, 70);
            font-weight: bold;
            border-radius: 3px;
            width: 100%;
            padding: 0;
            & span {
                padding: 7px 0;
            }
        }
    }
}
</style>

